var _defs, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "wave",
    style: {
      transform: "rotate(0deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 470",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(145, 62, 243, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(111, 116, 235, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,423L48,423C96,423,192,423,288,399.5C384,376,480,329,576,297.7C672,266,768,251,864,266.3C960,282,1056,329,1152,297.7C1248,266,1344,157,1440,125.3C1536,94,1632,141,1728,148.8C1824,157,1920,125,2016,125.3C2112,125,2208,157,2304,148.8C2400,141,2496,94,2592,117.5C2688,141,2784,235,2880,274.2C2976,313,3072,298,3168,266.3C3264,235,3360,188,3456,203.7C3552,219,3648,298,3744,274.2C3840,251,3936,125,4032,62.7C4128,0,4224,0,4320,70.5C4416,141,4512,282,4608,344.7C4704,407,4800,392,4896,352.5C4992,313,5088,251,5184,188C5280,125,5376,63,5472,54.8C5568,47,5664,94,5760,156.7C5856,219,5952,298,6048,313.3C6144,329,6240,282,6336,282C6432,282,6528,329,6624,289.8C6720,251,6816,125,6864,62.7L6912,0L6912,470L6864,470C6816,470,6720,470,6624,470C6528,470,6432,470,6336,470C6240,470,6144,470,6048,470C5952,470,5856,470,5760,470C5664,470,5568,470,5472,470C5376,470,5280,470,5184,470C5088,470,4992,470,4896,470C4800,470,4704,470,4608,470C4512,470,4416,470,4320,470C4224,470,4128,470,4032,470C3936,470,3840,470,3744,470C3648,470,3552,470,3456,470C3360,470,3264,470,3168,470C3072,470,2976,470,2880,470C2784,470,2688,470,2592,470C2496,470,2400,470,2304,470C2208,470,2112,470,2016,470C1920,470,1824,470,1728,470C1632,470,1536,470,1440,470C1344,470,1248,470,1152,470C1056,470,960,470,864,470C768,470,672,470,576,470C480,470,384,470,288,470C192,470,96,470,48,470L0,470Z"
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-1",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(62, 243, 96, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(99, 255, 144, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 50px)",
      opacity: 0.9
    },
    fill: "url(#sw-gradient-1)",
    d: "M0,329L48,321.2C96,313,192,298,288,297.7C384,298,480,313,576,305.5C672,298,768,266,864,211.5C960,157,1056,78,1152,94C1248,110,1344,219,1440,227.2C1536,235,1632,141,1728,109.7C1824,78,1920,110,2016,117.5C2112,125,2208,110,2304,148.8C2400,188,2496,282,2592,321.2C2688,360,2784,345,2880,313.3C2976,282,3072,235,3168,188C3264,141,3360,94,3456,133.2C3552,172,3648,298,3744,289.8C3840,282,3936,141,4032,94C4128,47,4224,94,4320,125.3C4416,157,4512,172,4608,148.8C4704,125,4800,63,4896,101.8C4992,141,5088,282,5184,352.5C5280,423,5376,423,5472,407.3C5568,392,5664,360,5760,321.2C5856,282,5952,235,6048,203.7C6144,172,6240,157,6336,188C6432,219,6528,298,6624,321.2C6720,345,6816,313,6864,297.7L6912,282L6912,470L6864,470C6816,470,6720,470,6624,470C6528,470,6432,470,6336,470C6240,470,6144,470,6048,470C5952,470,5856,470,5760,470C5664,470,5568,470,5472,470C5376,470,5280,470,5184,470C5088,470,4992,470,4896,470C4800,470,4704,470,4608,470C4512,470,4416,470,4320,470C4224,470,4128,470,4032,470C3936,470,3840,470,3744,470C3648,470,3552,470,3456,470C3360,470,3264,470,3168,470C3072,470,2976,470,2880,470C2784,470,2688,470,2592,470C2496,470,2400,470,2304,470C2208,470,2112,470,2016,470C1920,470,1824,470,1728,470C1632,470,1536,470,1440,470C1344,470,1248,470,1152,470C1056,470,960,470,864,470C768,470,672,470,576,470C480,470,384,470,288,470C192,470,96,470,48,470L0,470Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave2);
export default __webpack_public_path__ + "static/media/wave2.caf472ed9286388e4d3612fec205e48b.svg";
export { ForwardRef as ReactComponent };